module.exports = generateShipmentNumber

// generates a 4 digit string between "0000" and "9999"
function generateShipmentNumber () {
  const number = Math.floor(Math.random() * 10000)
  return `0000${number}`.substr(-4)
}
